module.exports = __webpack_public_path__ + "img/cause2Green.a1c53ea0.png";